import React from "react";
import { Loader } from "@progress/kendo-react-indicators";

function Loading() {
  return (
    <Loader
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        zIndex: "99999",
        color:"var(--theme-color)"
      }}
      size="large"
      type={"converging-spinner"}
    />
  );
}
export default Loading;
  